import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

export const resetLocalAndSessionStores = (): void => {
  const {
    previousCohort,
    previousLeadId,
    ...globalLocalStoreInitialState
  } = useZustandGlobalLocalStore.getInitialState()
  useZustandGlobalLocalStore.setState(globalLocalStoreInitialState)

  const sessionInitialState = useZustandSessionStore.getInitialState()
  const sessionCurrent = useZustandSessionStore.getState()

  useZustandSessionStore.setState({
    ...sessionInitialState,
    cookieyesConsent: sessionCurrent.cookieyesConsent,
    language: sessionCurrent.language || sessionInitialState.language,
    isPrintablePdf: sessionCurrent.isPrintablePdf,
    isWebAppRedirect: sessionCurrent.isWebAppRedirect,
  })
}
